import { ApiError, apiClient } from '@/shared/api/http-client';

import type {
    GetTranscriptByIdOutput,
    GetTranscriptMetadataOutput,
} from '../model/transcript.types';

export const transcriptApi = {
    getById: async (
        transcriptId: string,
        signal?: AbortSignal,
    ): Promise<GetTranscriptByIdOutput | null> => {
        try {
            return await apiClient.get<GetTranscriptByIdOutput>(
                `/transcript/${transcriptId}`,
                signal,
            );
        } catch (error) {
            if (error instanceof ApiError && error.status === 404) {
                return null;
            }
            throw error;
        }
    },
    getMetadata: async (
        transcriptId: string,
        signal?: AbortSignal,
    ): Promise<GetTranscriptMetadataOutput | null> => {
        try {
            return await apiClient.get<GetTranscriptMetadataOutput>(
                `/transcript/${transcriptId}/metadata`,
                signal,
            );
        } catch (error) {
            if (error instanceof ApiError && error.status === 404) {
                return null;
            }
            throw error;
        }
    },
    delete: async (transcriptId: string, signal?: AbortSignal): Promise<void> => {
        return apiClient.delete<void>(`/transcript/${transcriptId}`, signal);
    },
};
